<app-admin-boilerplate>
    <h1>Manage User Permissions</h1>

    @if (users$ | async; as userTable){
        <table class="w-full">
            <thead>
                <th class="text-start min-w-10">Name</th>
                <th class="text-start">Email Address</th>
                <th class="text-start">Permissions</th>
                <th></th>
                <th></th>
            </thead>
            <tbody>
                @if (userTable){
                    <!-- @for (user of userTable; track user.id){
                        <tr [routerLink]="[user.id]">
                            <td>{{ user.firstname | titlecase }} {{ user.surname | titlecase }}</td>
                            <td>{{ user.email }}</td>
                            <td class="my-auto">
                                <div class="flex gap-3">
                                    @if (checkPermission(user,['admin','superAdmin'])){
                                        <fa-icon [class.text-lrpTicketBlue]="checkPermission(user,['admin'])" [class.text-orange-500]="checkPermission(user,['superAdmin'])" [icon]="['fas','star']" title="Administrator"/>
                                    }
                                    @if (checkPermission(user,['preview'])){
                                        <fa-icon [icon]="['fas','eye']" title="Beta Preview"/>
                                    }
                                    @if (checkPermission(user,['eventSystem']) || (user.eventSystems?.length ?? 0) > 0){
                                        <fa-icon [icon]="['fas','sitemap']" title="Can manage one or more Event Systems"/>
                                    }
                                    @if (checkPermission(user,['eventHost']) || (user.eventHosts?.length ?? 0) > 0){
                                        <fa-icon [icon]="['fas','people-roof']" title="Can manage one or more Event Hosts"/>
                                    }
                                </div>
                            </td>
                            <td class="">
                                <ul>
                                    @for (eventSystem of user.eventSystems; track eventSystem){
                                        <li>{{ eventSystem }}</li>
                                    }
                                    @for (eventHost of user.eventHosts; track eventHost){
                                        <li>{{ eventHost }}</li>
                                    }
                                </ul>
                            </td>
                        </tr>

                    } -->
                }
            </tbody>
        </table>
    }
</app-admin-boilerplate>